"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftPresetGallery = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("react");
const enums_1 = require("@bemlo/enums");
const schedule_1 = require("@bemlo/schedule");
const constants_1 = require("../../constants");
const elements_1 = require("../../elements");
const translate_1 = require("../../translate");
const NewShift_1 = require("./composable/components/NewShift");
const Gallery = styled_1.default.div({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(110px, 1fr))',
    gap: constants_1.theme.spacing['1.5'],
    flex: 1,
    button: { height: '100%' },
});
const useShiftPresetDayjs = (presets) => {
    const t = (0, translate_1.useTranslations)();
    return (0, react_1.useMemo)(() => {
        return presets.map((preset) => {
            const date = t.$date().format('YYYY-MM-DD');
            const dateTime = (0, schedule_1.fromDateTimeComponentsWithOnCall)(date, preset.startTime, preset.endTime, preset.onCallTime);
            const onCallTime = dateTime.onCallTime && preset.onCallTime
                ? {
                    type: preset.onCallTime.type,
                    startDateTime: dateTime.onCallTime.startDateTime,
                    endDateTime: dateTime.onCallTime.endDateTime,
                    startTime: preset.onCallTime.startTime,
                    endTime: preset.onCallTime.endTime,
                }
                : null;
            const durations = (0, schedule_1.getShiftDurations)({
                ...dateTime,
                onCallTime,
                breakTime: preset.breakTime,
            });
            const dayjsShift = {
                id: preset.key,
                startDateTime: dateTime.startDateTime,
                endDateTime: dateTime.endDateTime,
                onCallTime,
                durations,
                activity: enums_1.ShiftActivity.WORK,
                date,
                startTime: preset.startTime,
                endTime: preset.endTime,
                breakTime: preset.breakTime,
                comment: preset.comment,
            };
            return { preset, dayjsShift };
        });
    }, [presets]);
};
const ShiftPresetGallery = (props) => {
    const t = (0, translate_1.useTranslations)();
    const dayjsPresets = useShiftPresetDayjs(props.presets);
    return ((0, jsx_runtime_1.jsxs)(Gallery, { children: [dayjsPresets.map(({ preset, dayjsShift }) => {
                const isSelected = props.selected === preset.key;
                return ((0, jsx_runtime_1.jsx)(NewShift_1.NewShift, { shift: dayjsShift, status: isSelected ? 'ACTIVE_PRESET' : 'PRESET', shiftIds: [preset.key], onClick: () => props.onSelect(preset.key) }, preset.key));
            }), (0, jsx_runtime_1.jsx)(elements_1.Button, { onClick: props.onClickNew, icon: "PlusIcon", design: "transparent-light", styles: { width: '100px', border: constants_1.theme.border.style.thinDark }, children: t.shifts.new() })] }));
};
exports.ShiftPresetGallery = ShiftPresetGallery;
